import React from "react";
import { CloseIcon } from "../../utils/icons";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SlideUpTransition from "../../components/SlideUpTransition";

import Button from "../../components/Controls/Button";
import PincodeEntryAction from "./ActionItem/PincodeEntryAction";
import { usePincodeModal } from "../../containers/PincodeModalProvider";
import { Text } from "../../utils/style/texts";
import { Colors } from "../../utils/style/colors";

import { IconButton } from "../IconButton";

const PincodeDialog = ({ user, show, close, start, tileConfig }) => {
  const [t] = useTranslation();

  const { activePincode, closePincodeModal, tempUnlock, isPincodeOpen } =
    usePincodeModal();
  const [pincodeVal, setPincodeVal] = React.useState(
    Array(activePincode?.current?.pincode?.split("").length).fill("")
  );
  const [wrongPin, setWrongPin] = React.useState(false);

  //   const [config, setConfig] = React.useState({});

  //   React.useEffect(() => {
  //     if (show)
  //       setTimeout(() =>
  //         setConfig({
  //           ...config,
  //           name: config?.name || t("pincodeEntry"),
  //         })
  //       );
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [show, t, setConfig]);

  React.useEffect(() => {
    if (wrongPin && pincodeVal.some((d) => d !== "")) {
      setWrongPin(false);
    }
  }, [pincodeVal, wrongPin]);

  const populatePincode = () => {
    const raw = activePincode?.current?.pincode;
    const str = raw == null ? "" : String(raw);
    const length = str.length;
    setPincodeVal(Array.from({ length }, () => ""));
  };

  React.useEffect(() => {
    if (!isPincodeOpen) return;
    setWrongPin(false);
    populatePincode();
  }, [isPincodeOpen, activePincode?.current?.pincode]);

  const pincodeSuccess = () => {
    tempUnlock(activePincode?.current?.type);
    activePincode?.current?.callback();

    closePincodeModal();
  };

  const submit = () => {
    if (pincodeVal.join("") === activePincode?.current?.pincode)
      pincodeSuccess();
    else {
      setPincodeVal(
        Array(activePincode?.current?.pincode?.split("").length).fill("")
      );
      setWrongPin(true);
    }
  };

  return (
    <Dialog
      open={isPincodeOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return;
        closePincodeModal();
      }}
      TransitionComponent={SlideUpTransition}
      fullWidth
      maxWidth="sm"
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle
          sx={{
            fontSize: 22,
            fontWeight: "bold",
          }}
        >
          {t("pincodeEntry")}
        </DialogTitle>
        <IconButton
          style={{ marginRight: 10 }}
          onClick={() => {
            closePincodeModal();
          }}
        >
          <CloseIcon size={1.2} />
        </IconButton>
      </div>
      <Divider
        sx={{
          marginBottom: 2,
        }}
      />
      <DialogContent>
        <PincodeEntryAction
          //   activePincode={}/
          onEnter={submit}
          pincodeVal={pincodeVal}
          setPincodeVal={setPincodeVal}
        />
        {wrongPin ? (
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 20,
            }}
          >
            <Text style={{ color: "#780606", fontSize: 16, fontWeight: "600" }}>
              {t("incorrectPin")}
            </Text>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flex: 1,
              height: 38,
            }}
          ></div>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          marginBottom: 3,
        }}
      >
        <Button
          onClick={() => {
            closePincodeModal();
          }}
          style={{
            width: 150,
            backgroundColor: Colors.white,
            border: "0.2px solid gray",
          }}
        >
          <Text> {t("cancel")}</Text>
        </Button>
        <Button
          onClick={submit}
          color="primary"
          style={{
            width: 150,
            border: "0.2px solid",
            borderColor: Colors.primary,
          }}
        >
          <Text style={{ color: Colors.white }}>{t("submitPin")}</Text>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PincodeDialog;
